import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: "maxLength"
})

export class MaxLengthPipe implements PipeTransform{
    transform(nom, prenom) {
        let fullString = nom + " " + prenom;
        return fullString.length > 25 ? `${fullString.substring(0, 25)} ...` : fullString
    }
}